<template>
  <PageTemplate>
    <div class="d-flex justify-content-between">
      <h6 class="element-header">
        {{ $t('general.change_password') }}
      </h6>
    </div>

    <div class="element-box">
      <h5 class="form-header mb-4">
        Mitarbeiter - {{ piniaCurrentUser?.firstName }} {{ piniaCurrentUser?.lastName }}
      </h5>

      <form @submit.prevent="changePassword" novalidate>
        <div class="row">
          <div class="col-lg-4">
            <BaseInput v-model="formData.password"
                       type="password"
                       label="Neues Passwort"
                       :required=true
                       :validation="v$.password"
                       :messages="v$.password.required.$message">
            </BaseInput>
          </div>
        </div>
        <div class="form-buttons-w">
          <button class="btn btn-primary" type="submit">Bestätigen</button>
        </div>
      </form>
    </div>
  </PageTemplate>
</template>
<script setup>
import securityService from '@/api/Security/index';
import BaseInput from '@/components/base/BaseInput.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { requiredRule } from '@/shared/validators/validationRules';
import { piniaUserStore } from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);

const { t }    = useI18n();
const formData = ref({
  password: '',
});

const rules = computed(() => {
  return {
    password: requiredRule(t),
  };
});

const v$ = useVuelidate(rules, formData);

async function changePassword() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  try {
    await securityService.changePassword(formData.value);
    await router.push({ path: '/dashboard/info' });
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}
</script>